import { Col, Row } from 'react-bootstrap';
import VerticalNavigation from '../navigation/vertical-navigation';
import React from 'react';
import LeftSide from '../main/left-side';
import Navbar from '../navigation/navbar';
import OperationalContactsListCard from './operational-contacts-list-card';
import ObjectsOverviewCard from '../objects/objects-overview-card';
import useTranslate from '../useTranslate';

function OperationalContactsScreen() {
    const strings = useTranslate('OperationalContactsList');
    return (
        <Navbar nav>
            <Row>
                <LeftSide addClass="">
                    <VerticalNavigation selected="operational-contacts" />
                </LeftSide>
                <Col xs={9} className="col-middle">
                    <Row>
                        <Col xs={12}>
                            <OperationalContactsListCard />
                        </Col>
                    </Row>
                    <ObjectsOverviewCard
                        title={strings.objectsTitle}
                        allowCreate={false}
                    />
                </Col>
            </Row>
        </Navbar>
    );
}

export default OperationalContactsScreen;
